export default class RPTerminWaehlenRequest {
  personen: number
  zeitVon: string
  zeitBis: string
  aussenbereich: boolean
  raucher: boolean
  tischId: string
  identifier: string
}
